/* FUZ redesign — tiny system-level JS. No libraries.
   1. scroll fade-ins (IntersectionObserver, reduced-motion + no-JS safe)
   2. header Buy button turns tangerine only after the page's primary CTA
      scrolls out of view (keeps tangerine to one per screen)
   3. mobile sticky add-to-cart bar on product pages (same observer) */
(function () {
  'use strict';

  document.documentElement.classList.add('fuz-js');

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- scroll fade-ins -------------------------------------------------- */
  /* when native scroll-driven animations are supported, CSS handles all
     reveal motion — skip the observer entirely */
  var scrollTimelines =
    typeof CSS !== 'undefined' && CSS.supports && CSS.supports('animation-timeline: view()');

  var faders = document.querySelectorAll('[data-fuz-fade]');
  if (!scrollTimelines && !reduceMotion && 'IntersectionObserver' in window && faders.length) {
    var fadeIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('fuz-in');
            fadeIO.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.05 }
    );
    faders.forEach(function (el) { fadeIO.observe(el); });
  } else {
    faders.forEach(function (el) { el.classList.add('fuz-in'); });
  }

  /* ---- header buy state + sticky product bar ----------------------------
     A page can have several primary CTAs (hero, final CTA, add-to-cart).
     The header buy button only goes tangerine when NONE of them are on
     screen, so tangerine never appears twice at once. */
  var header = document.querySelector('.fuz-header');
  var primaryCtas = document.querySelectorAll('[data-fuz-primary-cta]');
  var stickybar = document.querySelector('.fuz-stickybar');
  var visibleCtas = new Set();

  function setBuyLive(live) {
    if (header) header.classList.toggle('fuz-buy-live', live);
    if (stickybar) stickybar.classList.toggle('fuz-stickybar--show', live);
  }

  if (primaryCtas.length && 'IntersectionObserver' in window) {
    var ctaIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) visibleCtas.add(entry.target);
          else visibleCtas.delete(entry.target);
        });
        setBuyLive(visibleCtas.size === 0);
      },
      { threshold: 0 }
    );
    primaryCtas.forEach(function (el) { ctaIO.observe(el); });
  } else {
    // no primary CTA on this page (cart, policies, 404…) — buy stays live
    setBuyLive(true);
  }

  /* ---- tonal ramp: the page canvas crossfades between "rooms" ----------- */
  var canvas = document.getElementById('MainContent');
  var themeMap = { 'fuz-hero': 'deep', 'fuz-cta': 'deep', 'fuz-story': 'raised', 'fuz-mission': 'raised' };
  var themedSections = document.querySelectorAll(
    '.fuz-hero, .fuz-values, .fuz-anatomy, .fuz-compare, .fuz-faces, .fuz-story, .fuz-mission, .fuz-faq, .fuz-cta'
  );
  if (canvas && themedSections.length && 'IntersectionObserver' in window) {
    var themeIO = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var theme = 'base';
          for (var cls in themeMap) {
            if (entry.target.classList.contains(cls)) { theme = themeMap[cls]; break; }
          }
          canvas.setAttribute('data-fuz-theme', theme);
        });
      },
      { rootMargin: '-50% 0% -50% 0%', threshold: 0 }
    );
    themedSections.forEach(function (el) { themeIO.observe(el); });
  }

  /* ---- header shadow on scroll ------------------------------------------ */
  function onScroll() {
    if (header) header.classList.toggle('fuz-header--scrolled', window.scrollY > 8);
  }
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });
})();
